// extracted by mini-css-extract-plugin
module.exports = {"header":"_80ad21f8ef--header--1ujoQ","icon":"_80ad21f8ef--icon--3qz5t"};